import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Select } from "antd";
import axiosInstance from "../../../variables/api/axiosInstance";

const AddTaxe = ({ show, handleClose, editMode, codeId, selectedTaxe, taxes = [], onSaveSuccess, onSaveError }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pourcentage, setPourcentage] = useState("");
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState("");
  const [garanties, setGaranties] = useState([]);
  const [selectedGaranties, setSelectedGaranties] = useState([]);

  useEffect(() => {
    if (editMode && selectedTaxe) {
      setNom(selectedTaxe.libelleTaxe);
      setPourcentage(selectedTaxe.valeur);
      setDescription(selectedTaxe.description);
      setSelectedGaranties(selectedTaxe.garanties.map((gar) => gar.codeId));
    } else {
      setNom("");
      setPourcentage("");
      setDescription("");
      setSelectedGaranties([]);
    }
  }, [editMode, selectedTaxe]);

  useEffect(() => {
    axiosInstance.get(`/api/categorie`).then((res) => setCategories(res.data)).catch(console.log);

    axiosInstance.get(`/api/garantie`).then((res) => setGaranties(res.data)).catch(console.log);
  }, []);

  const handleChange = (value) => {
    setSelectedGaranties(value);
  };

  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    return sorted1.every((val, i) => val === sorted2[i]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Vérification des doublons : même nom, valeur et garanties
    const isDuplicate = !editMode && taxes.some((t) => {
      return (
        t.libelleTaxe?.trim().toLowerCase() === nom.trim().toLowerCase() &&
        parseFloat(t.valeur) === parseFloat(pourcentage) &&
        arraysEqual(t.garanties.map(g => g.codeId), selectedGaranties)
      );
    });

    if (isDuplicate) {
      toast.error("Une taxe avec ces informations existe déjà.");
      setLoading(false);
      return;
    }

    const selectedGarantiesObjects = selectedGaranties.map((id) =>
      garanties.find((gar) => gar.codeId === id)
    );

    const tax = {
      ...selectedTaxe,
      libelleTaxe: nom.trim(),
      description: description.trim(),
      valeur: parseFloat(pourcentage),
      garanties: selectedGarantiesObjects,
    };

    const request = editMode
      ? axiosInstance.put(`/api/taxe`, tax)
      : axiosInstance.post(`/api/taxe`, tax);

    request.then(() => {
      toast.success(editMode ? "Taxe modifiée avec succès" : "Taxe ajoutée avec succès");
      setLoading(false);
      handleClose();
      onSaveSuccess?.();
    }).catch(() => {
      toast.error(editMode ? "Erreur lors de la modification" : "Erreur lors de l'ajout");
      setLoading(false);
      onSaveError?.();
    });
  };

  return (
    <div size="md" centered>
      <div className="text-center mb-4">
        <h4>{editMode ? "Modifier la taxe" : "Ajouter une taxe"}</h4>
      </div>
      <form className="row g-3" onSubmit={onSubmit}>
        <div className="col-12">
          <label className="form-label">Nom</label>
          <input
            type="text"
            className="form-control"
            placeholder="Nom de la taxe"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            required
          />
        </div>
        <div className="col-12">
          <label className="form-label">Pourcentage</label>
          <input
            type="number"
            className="form-control"
            placeholder="Valeur en %"
            value={pourcentage}
            onChange={(e) => setPourcentage(e.target.value)}
            required
            min="0"
          />
        </div>
        <div className="col-12">
          <label className="form-label">Garanties</label>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Sélectionnez les garanties"
            onChange={handleChange}
            value={selectedGaranties}
            options={garanties.map((gar) => ({
              label: `${gar.nom} - ${gar?.categorie?.nom}`,
              value: gar.codeId,
            }))}
          />
        </div>
        <div className="col-12">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>
        <div className="col-12 text-center mt-3">
          <button type="submit" className="btn btn-primary me-2" disabled={loading}>
            {loading ? "Enregistrement..." : "Enregistrer"}
          </button>
          <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={loading}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddTaxe;
